import { useCallback, useEffect, useMemo } from 'react';
import { loadStripe } from '@stripe/stripe-js';
import {
  EmbeddedCheckoutProvider,
  EmbeddedCheckout,
} from '@stripe/react-stripe-js';
import { Stack, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';

const EmbedStripe = () => {
  const uniqueId = sessionStorage.getItem('uniqueId');
  const isMedicare = sessionStorage.getItem('isMedicare') === 'true';
  const isStaging =
    window.location.hostname.includes('staging') ||
    window.location.hostname.includes('localhost');

  const stripePromise = useMemo(() => {
    if (
      typeof window === 'undefined' ||
      typeof navigator === 'undefined' ||
      /bot|crawler|spider|crawling/i.test(navigator.userAgent)
    ) {
      console.warn('Skipping Stripe load: non-browser or bot detected');
      return null;
    }
    return loadStripe(import.meta.env.VITE_STRIPE_PROD);
  }, []);

  const navigate = useNavigate();
  useEffect(() => {
    if (!uniqueId) {
      setTimeout(() => {
        navigate('/');
      }, 3000);
    }
  }, [uniqueId, navigate]);

  const fetchClientSecret = useCallback(async () => {
    try {
      const res = await fetch(
        isStaging
          ? 'https://stripeinitv2staging-qqjaqi7y5q-uc.a.run.app'
          : 'https://stripeinitv2-qqjaqi7y5q-uc.a.run.app',
        {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            uniqueId,
            isMedicare,
            isEmbeded: true,
          }),
        }
      );

      const data = await res.json();

      if (!data.clientSecret || typeof data.clientSecret !== 'string') {
        throw new Error('clientSecret missing or invalid');
      }

      return data.clientSecret;
    } catch (err) {
      console.error('Error fetching client secret:', err);
      return '';
    }
  }, [isMedicare, isStaging, uniqueId]);

  const options = { fetchClientSecret };

  if (!uniqueId) {
    return (
      <Stack
        height="100vh"
        alignItems="center"
        justifyContent="center"
        bgcolor="white">
        <Typography variant="h5" color="textPrimary">
          No session found. Redirecting to home...
        </Typography>
      </Stack>
    );
  }

  return (
    <Stack
      className="checkout"
      bgcolor={'white'}
      id="checkout"
      height={'100vh'}
      width="100%"
      justifyContent="center"
      alignItems="stretch">
      <EmbeddedCheckoutProvider stripe={stripePromise} options={options}>
        <EmbeddedCheckout />
      </EmbeddedCheckoutProvider>
    </Stack>
  );
};

export default EmbedStripe;
